export default __webpack_public_path__ + "static/media/playstation-user.7b196def.svg";